module.exports = __webpack_public_path__ + "img/bolsa2.be5a75e6.jpg";